export default __webpack_public_path__ + "static/media/rightBtn.b74da334.mp3";